<template>
<div class="container-main">
	<Header/>
    <component :is="pageComp"></component>
</div>
</template>

<script>

import Vue from 'vue'
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'


import Header from './components/Header.vue'
import ThemeMixin from '@/libs/mixins/themeMixin.js'

export default {
    mixins: [ThemeMixin],
    data: function () {
        return {
        }
    },
    components: {
        Header,
	},
	created() {
        this.loadComponent()
	},
    mounted() {
        document.querySelector('meta[property="og:image"]').setAttribute("content", 'thumbnai2.jpg');
    },
    methods: {
        loadComponent() {
            const requireComponent = require.context('./', false, /\.vue$/i);
            requireComponent.keys().forEach(fileName => {

                const componentConfig = requireComponent(fileName)
                const componentName = upperFirst(
                    camelCase(
                        fileName.split('/')
                        .pop()
                        .replace(/\.\w+$/, '')
                    )
                )
                
                Vue.component(
                    componentName,
                    componentConfig.default || componentConfig
                )
            })
        }
    },
}
</script>

<style lang="scss" scoped>
    html {
        font-size: 16px;
    }
    // .container {
    //     min-height: 49.5rem;
    // }
    .table.table-bordered > :not(caption) > * {
        border-width: 3px 3px;
        border-color: black;
    }
    img {
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    body {
        font-family: 'Montserrat', sans-serif !important
    }
    .container-main {
        background: url('~@/assets/background_new.jpg');
        background-size: 30px 30px;
        position: relative;
        min-height: calc(100vh);
    }

    .loading-screen {
        display: none;
        width: 100%;
        height: 100vh;
        background-color: #0000004d;
        position: fixed;
        z-index: 99999999;
    }

    .loading-screen.show {
        display: block !important;
    }
    .box-paper {
        position: relative;
        text-align: center;
        img{
            max-width: 68rem;
        }
        .box-time{
            z-index: 10000;
            position: absolute;
            right: 7.4rem;
            top: 0.6rem;
            font-size: 1.8rem;
            font-weight: bold;
            color: white;
            text-shadow: 2px 0 black, -2px 0 black, 0 2px black, 0 -2px black, 1px 1px black, -1px -1px black, 1px -1px black, -1px 1px black;
        }
        .box-text {
            position: absolute;
            bottom: 1.6rem;
            left: 12.5rem;
            line-height: 1.65;
            textarea{
                border: none;
                overflow: auto;
                outline: none;
                background: none;
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;

                resize: none; /*remove the resize handle on the bottom right*/
            }
        }
    }
    .box-button {
        text-align: center;
        position: relative;
        top: -1.5rem;
        z-index: 1000;
        .button-next, .button-support, .button-nhap {
            position: relative;
            cursor: pointer
        }
        .button-support{
            max-width: 10rem;
            left: 13.5rem;
            top: 1rem;
        }
        .button-nhap {
            left: 10.5rem;
            top: 1rem;
            max-width: 5rem;
        }
        .button-next {
            max-width: 10rem;
            left: 3rem;
        }
    }
    #bv-modal-next {
        .modal-content {
            background:none;
            border: none;
        }
        .box-modal-next {
            img {
                width: 100%;
            }
            .modal-box-button{
                text-align: center;
                top: -9.4rem;
                position: relative;
                &.submit {
                    top: -4.4rem;
                }
                .modal-button_next, .modal-button_cancel {
                    font-weight: 700;
                    min-width: 7rem;
                    font-style: italic;
                }
                .modal-button_next {
                    background-color: #009933;
                }
                .modal-button_cancel {
                    margin-right: 3rem;
                    background-color: #cc0000;
                }
            }

        }
    }
    
    @media (min-width: 720px) and (max-width: 992px) {
        html {
            font-size: 54%;
        }
        .box-paper {
            .box-time {
                right: 7.8rem;
            }
        }
    }
    @media (min-width: 993px) and (max-width: 1023px) {
        html {
            font-size: 70%;
        }
        .box-paper {
            .box-time {
                right: 9rem;
            }
        }
    }
    @media (min-width: 1024px) and (max-width: 1200px) {
        html {
            font-size: 72%;
        }
        .box-paper {
            .box-time{
                right: 7.8rem;
                top: 0.5rem;
            }
        }
    }
    @media (min-width: 1201px) and (max-width: 1400px) {
        html {
            font-size: 88%;
        }
        .box-paper {
            .box-time{
                right: 6.6rem;
                top: 0.5rem;
            }
        }
    }
</style>
